import { post, get } from '@/utils/request';

const url = {
    liveInfo: '/open/live/info',
    checkPassword: '/open/live/password/check',
};

export default {
  getLiveInfo(params = {}, options = {}) {
    return post({
      url: url.liveInfo,
      data: params,
      options,
    });
  },
  checkPassword(params = {}, options = {}) {
    return post({
      url: url.checkPassword,
      data: params,
      options,
    });
  },
};
